export const passwordCheck = (pwd: string) => {
    let setNum = "0123456789";
    let setAlpha1 = "abcdefghijklmnopqrstuvwxyz";
    let setAlpha2 = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    let setOther = "`~!@#$%^&*()-_=+|]}[{'\";:/?.>,<";
    let varDigit = 0;
    let varAlpha = 0;
    let varSpecial = 0;
    let str1 = pwd;
    for (let i = 0; i < str1.length; i++) {
        if (setNum.indexOf(str1.charAt(i)) > -1) {
            varDigit = 1;
        } else if (setAlpha1.indexOf(str1.charAt(i)) > -1) {
            varAlpha = 1;
        } else if (setAlpha2.indexOf(str1.charAt(i)) > -1) {
            varAlpha = 1;
        } else if (setOther.indexOf(str1.charAt(i)) > -1) {
            varSpecial = 1;
        } else {
            if (" " === str1.charAt(i)) {
                return "비밀번호에는 공백을 사용할 수 없습니다.";
            } else {
                return "사용 불가한 문자가 포함되어있습니다.";
            }
        }
    }

    if ((varDigit + varAlpha + varSpecial) < 3) {
        return "비밀번호는 영문자, 숫자, 특수문자를 혼합하여 사용해야 합니다.";
    }

    if (duplicateCharCheck(pwd)) {
        return "3자 이상 동일한 문자는 사용 불가 합니다.";
    }

    if (continuesCharCheck(pwd)) {
        return "3자 이상 연속된 문자는 사용 불가 합니다.";
    }

    return "SUCC";
}

export const duplicateCharCheck = (pwd: string) => {
    //결과값 초기화
    let checkValue = false;

    //임시 배열 선언
    let tempArray: number[] = [];
    for (let i = 0; i < pwd.length; i++) {
        tempArray[i] = pwd.charCodeAt(i);
    }
    /*중복된 3자 이상의 문자 또는 숫자 사용불가*/
    for (let i = 0; i < tempArray.length - 1; i++) {
        if ((eval(tempArray[i].toString()) === eval(tempArray[i + 1].toString())) && (eval(tempArray[i].toString()) === eval(tempArray[i + 2].toString()))) {
            checkValue = true;
            return true;
        } else {
            checkValue = false;
        }
    }
    return checkValue;
}

export const continuesCharCheck = (pwd: string) => {
    //결과값 초기화
    let checkValue = false;

    //임시 배열 선언
    let tempArray: number[] = [];
    for (let i = 0; i < pwd.length; i++) {
        tempArray[i] = pwd.charCodeAt(i);
    }

    //연속된 3개의 문자 사용불가 (오름차순)
    for (let i = 0; i < tempArray.length - 1; i++) {
        if ((eval((tempArray[i] + 1).toString()) === eval(tempArray[i + 1].toString())) && (eval((tempArray[i + 1] + 1).toString()) === eval(tempArray[i + 2].toString()))) {
            checkValue = true;
            return true;
        } else {
            checkValue = false;
        }
    }

    //연속된 3개의 문자 사용불가 (내림차순)
    for (let i = 0; i < tempArray.length - 1; i++) {
        if ((eval(tempArray[i].toString()) === eval((tempArray[i + 1] + 1).toString())) && (eval(tempArray[i].toString()) === eval((tempArray[i + 2] + 2).toString()))) {
            checkValue = true;
            return true;
        } else {
            checkValue = false;
        }
    }
    return checkValue;
}